import { Flex, HStack, Icon, Text } from '@chakra-ui/react';
import { ContactType } from '@client/graphql/__generated__/types';
import { CheckSquare, Square } from 'lucide-react';

interface RecipientsSelectProps {
  value: ContactType[];
  onChange: (value: ContactType[]) => void;
}

export const RecipientsSelect = ({
  value,
  onChange,
}: RecipientsSelectProps) => {
  const options = [
    { type: ContactType.AGENT, label: 'Agent', disabled: false },
    { type: ContactType.LOAN_OFFICER, label: 'Loan Officer', disabled: false },
    { type: ContactType.CLIENT, label: 'Client', disabled: true },
  ];

  const toggleRecipient = (type: ContactType) => {
    if (value.includes(type)) {
      // Don't allow removing all recipients
      if (value.length > 1) {
        onChange(value.filter((r) => r !== type));
      }
    } else {
      onChange([...value, type]);
    }
  };

  return (
    <Flex
      alignItems="center"
      borderBottom="1px solid"
      borderColor="whiteAlpha.100"
      justifyContent="space-between"
      py={5}
    >
      <Text color="whiteAlpha.700">Recipient(s)</Text>
      <HStack spacing={2}>
        {options.map((option) => {
          const isSelected = value.includes(option.type);

          return (
            <Flex
              key={option.type}
              alignItems="center"
              bg={isSelected ? 'white' : 'whiteAlpha.50'}
              border="1px solid"
              borderColor="whiteAlpha.100"
              borderRadius="sm"
              cursor={option.disabled ? 'not-allowed' : 'pointer'}
              gap={4}
              opacity={option.disabled ? 0.3 : 1}
              px={3}
              py={2}
              transition="all 0.2s"
              onClick={() => !option.disabled && toggleRecipient(option.type)}
            >
              <Text
                color={isSelected ? 'indigo.900' : 'white'}
                fontSize="sm"
                fontWeight="medium"
              >
                {option.label}
              </Text>
              <Icon
                as={isSelected ? CheckSquare : Square}
                boxSize={4}
                color={isSelected ? 'indigo.900' : 'whiteAlpha.400'}
              />
            </Flex>
          );
        })}
      </HStack>
    </Flex>
  );
};
